import { API_BASE_URL, authFetch } from './api';


export interface Brand {
  id: string;
  name: string;
  aliases: string[];
  commenting_guidelines: string;
  created_at: string;
  updated_at: string;
}

export interface CreateBrandPayload {
  name: string;
  aliases?: string[];
  commenting_guidelines?: string;
}

export interface UpdateBrandPayload {
  name?: string;
  aliases?: string[];
  commenting_guidelines?: string;
}

const BASE = `${API_BASE_URL}/brands`;

export async function listBrands(): Promise<Brand[]> {
  const res = await authFetch(BASE);
  return res.json();
}

export async function getBrand(id: string): Promise<Brand> {
  const res = await authFetch(`${BASE}/${id}`);
  return res.json();
}

export async function createBrand(payload: CreateBrandPayload): Promise<Brand> {
  const res = await authFetch(BASE, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function updateBrand(id: string, payload: UpdateBrandPayload): Promise<Brand> {
  const res = await authFetch(`${BASE}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function deleteBrand(id: string): Promise<{ success: boolean; orphaned_activities: number; orphaned_sessions: number }> {
  const res = await authFetch(`${BASE}/${id}`, { method: 'DELETE' });
  return res.json();
}
